import axiosClient from './axiosClient';
import datV2 from './datV2';

// Center hiện tại (single-tenant) — BE dùng để ghi audit log cabin vào
// đúng tenant (dat_action_logs.center là bắt buộc).
const DAT_CENTER = datV2.center;

const removeEmptyValues = (payload = {}) => {
  const cleanedPayload = { ...payload };
  Object.keys(cleanedPayload).forEach((key) => {
    if (cleanedPayload[key] === undefined || cleanedPayload[key] === null || cleanedPayload[key] === '') {
      delete cleanedPayload[key];
    }
  });
  return cleanedPayload;
};

const calcomService = {
  // Get all bookings
  getAllBookings: async (params = {}) => {
    const limit = 250;
    let skip = 0;
    let allBookings = [];

    while (true) {
      const response = await axiosClient.get('/calcom/bookings', {
        params: removeEmptyValues({ ...params, take: limit, skip }),
      });
      const data = response?.data?.data || response?.data || [];
      const rows = Array.isArray(data) ? data : data?.bookings || data?.data || [];

      allBookings = allBookings.concat(rows);

      if (rows.length < limit) break;
      skip += limit;
    }

    return { data: { data: allBookings } };
  },

  // Get a specific booking
  getBooking: async (bookingId, serviceKey) => {
    const response = await axiosClient.get(`/calcom/bookings/${bookingId}`, {
      params: removeEmptyValues({ serviceKey }),
    });
    return response;
  },

  // Lấy thông tin cơ bản học viên trên GetFly theo mã học viên (tra field
  // 119). Trả body { message, data: { accountId, mapper } }. Dùng cho nút
  // "Xem thông tin" ở trang admin cabin (hiển thị inline, không mở link).
  getStudentGetflyInfo: async (registrationCode) => {
    const response = await axiosClient.get('/calcom/student-getfly', {
      params: { registrationCode },
    });
    return response;
  },

  // Get available slots for an event type
  getAvailableSlots: async (eventTypeId, startTime, endTime, options = {}) => {
    const response = await axiosClient.get('/calcom/slots', {
      params: removeEmptyValues({
        eventTypeId,
        start: startTime,
        end: endTime,
        timeZone: 'Asia/Ho_Chi_Minh',
        format: 'range',
        ...options,
      }),
    });
    return response;
  },

  // Create a new booking. BE applies checkCreatePolicy when an lms_token
  // is in the body — student-mode requests are rejected with 409 if the
  // student already has an active cabin booking (double-booking guard).
  // Teacher/admin callers omit lmsToken and pass through without DB check.
  createBooking: async (bookingData, lmsToken) => {
    const body = lmsToken
      ? { ...bookingData, lmsToken, center: DAT_CENTER }
      : { ...bookingData, center: DAT_CENTER };
    const response = await axiosClient.post('/calcom/bookings', body);
    return response;
  },

  // Cancel a booking. BE enforces a policy check: admin Bearer is enough,
  // but a student initiating cancel from /cabin?lms_token=... must forward
  // their JWT in the body so BE can verify booking ownership. See
  // uniapp-backend src/controllers/calcom.controller-policy.js.
  cancelBooking: async (bookingUid, reason = '', serviceKey, lmsToken) => {
    const response = await axiosClient.post(
      `/calcom/bookings/${bookingUid}/cancel`,
      removeEmptyValues({
        cancellationReason: reason,
        serviceKey,
        lmsToken,
        center: DAT_CENTER,
      }),
    );
    return response;
  },

  // Mark booking as absent
  markAbsentBooking: async (bookingUid, payload = {}) => {
    const response = await axiosClient.post(
      `/calcom/bookings/${bookingUid}/mark-absent`,
      removeEmptyValues({ ...payload, center: DAT_CENTER }),
    );
    return response;
  },

  // Mark an event type busy on a date (full day or time range).
  // Backend resolves eventType -> schedule before applying busy logic.
  markEventTypeBusy: async (eventTypeId, payload = {}) => {
    const response = await axiosClient.post(
      `/calcom/event-types/${eventTypeId}/busy`,
      removeEmptyValues(payload),
    );
    return response;
  },

  // Remove busy mark on a date for an event type
  removeEventTypeBusy: async (eventTypeId, date, serviceKey) => {
    const response = await axiosClient.delete(
      `/calcom/event-types/${eventTypeId}/busy/${date}`,
      { params: removeEmptyValues({ serviceKey }) },
    );
    return response;
  },

  // Get per-day availability status (free / partial / busy) for an event type
  getEventTypeAvailability: async (eventTypeId, params = {}) => {
    const response = await axiosClient.get(
      `/calcom/event-types/${eventTypeId}/availability`,
      { params: removeEmptyValues(params) },
    );
    return response;
  },

  /**
   * Lịch đề nghị hủy — CHỈ ĐỌC.
   *
   * BE tự tải và phân trang bên trong, nhưng đại diện cho 3 cabin nên gọi này
   * mất vài giây — màn hình phải có trạng thái đang tải.
   *
   * Không có hàm hủy hàng loạt, và đó là chủ ý: hủy đi qua `cancelBooking` từng
   * dòng, đúng policy hủy đang có.
   */
  getLichCanHuy: (serviceKey) => {
    // Tra NGUYEN `{ message, data }` — dung quy uoc cua moi service khac trong
    // file nay. `axiosClient` da boc lop HTTP roi, nen boc them `.data` o day
    // la boc HAI lan: trang goi `res?.data` se nhan undefined, `kq` thanh null,
    // va man hinh hien TRONG ma khong bao loi gi. Da vap dung loi nay tren prod.
    return axiosClient.get('/calcom/audit/lich-can-huy', {
      params: removeEmptyValues({ serviceKey }),
    });
  },
};

export default calcomService;